module.exports = __webpack_public_path__ + "img/warning.b2d43408.svg";